// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"user-password"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.375 17.0029H18H20.625L21.5 17.6458V21.5001H14.5V17.6458L15.375 17.0029Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.5 15H8C5.23858 15 3 17.2386 3 20V21H10.5508M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18 17.0029V13H20M18 17.0029H15.375L14.5 17.6457V21.5H21.5V17.6457L20.625 17.0029H18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UserPasswordIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-password',
    ref,
    icon: element,
  },
));

UserPasswordIcon.displayName = 'UserPasswordIcon';

export default UserPasswordIcon;
